import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import PropTypes from "prop-types";

const ContactPage = ({phoneNumber}) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
        marginTop: "100px",
      }}
    >
      <Paper
        elevation={2}
        sx={{
          p: 2,
          textAlign: "left",
          height: 300,
          width: 320,
          mx: "auto",
        }}
      >
        <Grid container direction="column">
          <Grid item sx={{ mt: 0.5, textAlign: "center" }}>
            <VolunteerActivismIcon
              sx={{
                color: "#1c355e",
                width: 200,
                height: 200,
                opacity: 0.1,
              }}
            />
            <Typography
              sx={{
                textAlign: "center",
                zIndex: 10,
                fontSize: 20,
                mt: -22,
              }}
            >
              {t("steps.contactMessage")}
            </Typography>
          </Grid>

          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              width: "100%",
            }}
            mt={4}
          >
            <Grid>
              <Button
                variant="contained"
                size="medium"
                component="a"
                // href={`tel:${t(`brandInfo.brandPhone.${brand}`).replace(/\D/g, "")}`}
                href={`tel:${phoneNumber}`}
              >
                {/* {t(`brandInfo.brandPhone.${brand}`)} */}
                {phoneNumber}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};
ContactPage.propTypes = {
  phoneNumber: PropTypes.string,
};
export default ContactPage;
